import type { PackageStatus } from '@/features/package/domain/enums/PackageStatus'
import { PackageMonitoringFilterEntity } from '@/features/trackOrder/domain/entities/packageEntites/PackageMonitoringFilterEntity'
import { mapEntityProperties } from '@/utils/mapEntityProperties'

export class PackageMonitoringFilterModel extends PackageMonitoringFilterEntity {
  regionIds!: Array<number>
  declare packageStatuses: Array<PackageStatus>
  constructor(dataDto: PackageMonitoringFilterEntity) {
    super()
    mapEntityProperties<PackageMonitoringFilterModel>(this, dataDto, {
      exclude: ['regions'],
      map: {
        regionIds: dataDto.regions?.map((region) => region.id)
      }
    })
  }
}
